import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=09cc96ec&scoped=true&lang=pug&"
import script from "./Document.vue?vue&type=script&lang=js&"
export * from "./Document.vue?vue&type=script&lang=js&"
import style0 from "./Document.vue?vue&type=style&index=0&id=09cc96ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cc96ec",
  null
  
)

export default component.exports